/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { RetryPartnerCreatorResponse, RetryPartnerCreatorVars } from '../openapi-types.gen.js';

export type { RetryPartnerCreatorResponse, RetryPartnerCreatorVars } from '../openapi-types.gen.js';

export const useRetryPartnerCreator = createMutationHook<RetryPartnerCreatorVars, RetryPartnerCreatorResponse, unknown>({
  specName: 'useRetryPartnerCreator',
  path: '/v1/admin/creators/{id}/retry',
  method: 'POST',
  resolveUrl: (vars: RetryPartnerCreatorVars) => `/v1/admin/creators/${vars.id}/retry`,
  
  parseResponse: (raw: unknown): RetryPartnerCreatorResponse => raw as RetryPartnerCreatorResponse,
  optimistic: [{
    queryKey: ['admin', 'partner-creators'],
    apply: (prev: any, vars: RetryPartnerCreatorVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }, {
    queryKey: ['admin', 'partner-creator'],
    apply: (prev: any, vars: RetryPartnerCreatorVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }],
  
  
});
